<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    transition="dialog-transition"
    content-class="emailSent"
  >
    <v-card class="py-8 px-10 verify">
      <h3 class="mb-6">檢查您的信箱來驗證 Email</h3>
      <div class="d-flex align-center mb-6">
        <v-icon color="white" x-large>fa-envelope-open-text</v-icon>
        <div class="ml-8">
          <span>我們已經送出一封信件到您的 Email</span><br>
          <span class="font-weight-bold">{{ user.email }}</span><br>
          <span>請檢查您的Email以完成註冊</span><br>
          <span class="font-weight-bold caption red--text">(檢查垃圾郵件資料夾)</span>
        </div>
      </div>
      <a @click="!sending ? $emit('reSend') : ''" :class="['resend', {'not-allow': sending}]">
        <span :class="sending ? 'grey-1--text' : 'pink--text'">重新發送驗證碼 </span>
        <span v-if="sending">({{ time }})</span>
        <v-icon v-else x-small color="pink" class="pl-2">fa-chevron-right</v-icon>
      </a>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['time', 'sending'],
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapState('user', ['user'])
  },
}
</script>

<style lang="scss" scoped>
.emailSent {
  .v-card {
    color: white;
    background: $grey-3;
    div > span {
      font-weight: 300;
    }
  }
}
</style>